var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-form',{ref:"form"},[_c('v-row',[_c('v-text-field',{attrs:{"value":_vm.name,"label":"Name"}})],1),_c('v-row',[_c('v-spacer'),_c('v-btn',[_vm._v(" Save ")])],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }